"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccountVerificationUrl = void 0;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var getAccountVerificationUrl = function getAccountVerificationUrl() {
  return "/account-verification/" + _PortalIdParser.default.get() + "?source=FILE_MANAGER";
};

exports.getAccountVerificationUrl = getAccountVerificationUrl;